import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { RegisterPushWebParams } from './request';
import { registerPushWeb } from './request';

export const useRegisterPushWebMutation = (
  settings?: MutationSettings<RegisterPushWebParams, typeof registerPushWeb>
) =>
  useMutation({
    mutationKey: ['registerPushWeb'],
    mutationFn: ({ params, config }) => registerPushWeb({ params, config }),
    ...settings?.options
  });
